import { useNavigate } from 'react-router-dom';
import { Wallet, Crown, ArrowRight, Lock, Coins } from 'lucide-react';
import { useWallet } from '../../../../context/wallet/WalletContext';

const WalletBalanceCard = () => {
  const navigate = useNavigate();
  const {
    walletData,
    isLoading,
    isGrowthPlan,
    isGhostWallet,
    isSubAdmin,
    setIsRedeemModalOpen
  } = useWallet();

  const balance = walletData?.balance || 0;

  return (
    <div className="lg:col-span-7 rounded-3xl bg-gradient-to-br from-[#044d4c] via-[#067978] to-[#0a908f] p-5 sm:p-7 md:p-8 text-white shadow-xl shadow-[#067978]/15 relative overflow-hidden flex flex-col justify-between">
      {/* Background Ambient Aura */}
      <div className="absolute -right-12 -top-12 w-64 h-64 rounded-full bg-white/10 blur-2xl pointer-events-none" />
      <div className="hidden sm:flex absolute right-6 top-6 w-14 h-14 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 items-center justify-center text-white shadow-inner">
        <Wallet size={26} />
      </div>

      <div className="relative z-10 pr-0 sm:pr-16">
        <div className="flex flex-wrap items-center gap-2 mb-2">
          <span className="text-[11px] font-bold uppercase tracking-widest text-teal-100/90">
            Available Balance
          </span>
          {isGrowthPlan && (
            <span className="px-2 py-0.5 rounded-full bg-emerald-400/20 border border-emerald-300/30 text-emerald-200 text-[10px] font-bold">
              +20% Boost Active
            </span>
          )}
        </div>

        <div className="flex items-baseline gap-1.5 sm:gap-2 my-2 sm:my-3">
          <span className="text-2xl sm:text-3xl md:text-4xl font-semibold text-teal-200">₹</span>
          <span className="text-3xl sm:text-5xl md:text-6xl font-bold tracking-tight text-white break-all">
            {isLoading ? '...' : balance.toLocaleString('en-IN')}
          </span>
        </div>

        <p className="text-xs text-teal-100/80 font-medium">
          Available commission balance eligible for instant withdrawal.
        </p>
      </div>

      <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-white/15 flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 relative z-10">
        <div className="flex flex-wrap items-center gap-2.5 sm:gap-3">
          {isGhostWallet ? (
            <>
              <button
                disabled
                className="bg-white/20 text-white/80 px-4 sm:px-5 py-2 sm:py-2.5 rounded-xl font-semibold text-xs border border-white/20 cursor-not-allowed flex items-center gap-2 backdrop-blur-xs"
                title={isSubAdmin ? 'Only primary Admin can redeem funds' : 'Upgrade to Pro Plan to redeem wallet commissions'}
              >
                <Lock size={12} />
                <span>Redeem Funds</span>
              </button>
              <button
                onClick={() => navigate('/subscription')}
                className="bg-white hover:bg-teal-50 text-[#067978] px-4 sm:px-5 py-2 sm:py-2.5 rounded-xl font-bold text-xs flex items-center gap-2 shadow-lg shadow-black/10 transition-all active:scale-95 cursor-pointer"
              >
                <Crown size={14} className="text-[#067978]" />
                <span>Upgrade Plan</span>
                <ArrowRight size={13} />
              </button>
            </>
          ) : (
            <button
              onClick={() => setIsRedeemModalOpen(true)}
              disabled={!walletData || balance < 500}
              className="w-full sm:w-auto justify-center bg-white hover:bg-teal-50 text-[#067978] px-5 sm:px-6 py-2.5 rounded-xl font-bold text-xs shadow-lg shadow-black/15 transition-all active:scale-95 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              <Coins size={15} />
              <span>Redeem Funds</span>
            </button>
          )}
        </div>

        <div className="text-[10px] sm:text-[11px] text-teal-100/70 font-medium">
          Minimum payout: ₹500 · Instant UPI / Bank NEFT
        </div>
      </div>
    </div>
  );
};

export default WalletBalanceCard;
